import { UserOutlined } from '@ant-design/icons';
import { XIcon } from '@heroicons/react/outline';
import { Avatar, Button, Modal } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import type { FC } from 'react';

import { IAuthorDetailsList } from '@/utils/interfaces/landingPage';

interface BookAuthorsModalProps {
  isOpen: boolean;
  onClose: () => void;
  authors: IAuthorDetailsList[];
  landingPageData?: any;
}

const BookAuthorsModal: FC<BookAuthorsModalProps> = ({
  isOpen,
  onClose,
  landingPageData,
}) => {
  const screens = useBreakpoint();
  return (
    <Modal
      title={
        <span className='text-white text-lg  md:text-xl font-semibold'>
          Book Authors
        </span>
      }
      open={isOpen}
      onCancel={() => onClose()}
      footer={null}
      closable={true}
      closeIcon={<XIcon className='w-5 h-5 text-zinc-400 hover:text-white' />}
      centered
      width='min(90vw, 640px)'
      classNames={{
        header: 'bg-grayZl-950 text-white border-b border-grayZl-700',
        content: 'p-6 w-full bg-grayZl-950 md:rounded-xl',
      }}
    >
      <div className='grid xxxs:grid-cols-2 sm:grid-cols-3 mt-6 gap-2'>
        {landingPageData?.form?.authorsList?.map(
          (author: any, index: number) => (
            <div
              key={index}
              className='bg-[#FFFFFF0D] p-4 rounded-lg flex flex-col justify-between items-center text-center'
            >
              <Avatar
                size={screens.md ? 80 : 64}
                src={author?.authorImage}
                alt={author.authUser_name}
                icon={!author.authorImage && <UserOutlined />}
              >
                {!author.authorImage && author.authorName?.charAt(0)}
              </Avatar>
              <h3 className='mt-3 text-white font-medium line-clamp-1'>
                {author.authorName}
              </h3>
              <p className='text-sm text-grayZl-500 font-light line-clamp-1 mt-1'>
                {author.authorDesignation}
              </p>
              <Button
                ghost
                className='mt-4 w-full bg-transparent text-white  hover:bg-zinc-800 border-white hover:text-white'
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (author?.authorId) {
                    window.location.href = `/author/${author.authorId}`;
                  }
                }}
              >
                View Profile
              </Button>
            </div>
          ),
        )}
      </div>
    </Modal>
  );
};
export default BookAuthorsModal;
